import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  GET_PAYMENT,
  GET_PAYMENT_METHOD,
  GET_PAYMENT_METHOD_CREATED_BY
} from "../actions";
import {
  getPaymentSuccess,
  getPaymentError,
  getPaymentMethodSuccess,
  getPaymentMethodError,
  getPaymentMethodCreatedBySuccess,
  getPaymentMethodCreatedByError
} from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
import centralApiAxios from "../../axios/centralApiAxios";


const PaymentMethodGetFailed = "Get payment Method fails";

export function* watchGetPayment() {
  yield takeEvery(GET_PAYMENT, getPayment);
}

const getPaymentAsync = async (payload) => {
  try {

    const paymentReturned = await centralApiAxios.get(
      `/payments/${payload.paymentId}`, getActivityHeadersUpdated(payload)
    );

    if (paymentReturned.data) {
      return {
        payment: paymentReturned.data,
        message: null,
      };
    }

    return { message: "Get user info failed." };
  } catch (error) {
    return {
      message: "Failed to get contact. ",
    };
  }
};

function* getPayment({ payload }) {
  try {
    const returnedData = yield call(getPaymentAsync, payload);
    if (!returnedData.message) {
      yield put(
        getPaymentSuccess({
          payment: returnedData.payment
        })
      );
    } else {
      yield put(getPaymentError(returnedData.message));
    }
  } catch (error) {
    yield put(getPaymentError(error));
  }
}



export function* watchGetPaymentMethod() {
  yield takeEvery(GET_PAYMENT_METHOD, getPaymentMethod);
}
 
const getPaymentMethodAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get("payment_methods/" + payload.methodId, getActivityHeadersUpdated(payload));
    if (dataReturned.data) {
      return {
        paymentMethod: dataReturned.data,
        message: null,
      };
    }
    return { message: PaymentMethodGetFailed };
  } catch (error) {
    return {
      message: PaymentMethodGetFailed,
    };
  }
};

function* getPaymentMethod({ payload }) {
  try {
    const returnedData = yield call(getPaymentMethodAsync, payload);
    if (!returnedData.message) {
      yield put(getPaymentMethodSuccess({ paymentMethod: returnedData.paymentMethod }));
    } else {
      yield put(getPaymentMethodError(returnedData.message));
    }
  } catch (error) {
    yield put(getPaymentMethodError(error));
  }
}

export function* watchGetPaymentCreatedBy() {
  yield takeEvery(GET_PAYMENT_METHOD_CREATED_BY, getPaymentCreatedBy);
}

const getPaymentCreatedByAsync = async (payload) => {
  try {
    if (payload.createdById == 0) {
      return { message: "Get user info failed." };
    }

    if (payload.verbType == undefined) {
      payload.verbType = 2;
    }

    const contactReturned = await centralApiAxios.get(
      `/Contacts/${payload.createdById}?verbType=${payload.verbType}`, getActivityHeadersUpdated(payload)
    );

    if (contactReturned.data) {
      return {
        contact: contactReturned.data,
        contactTypes: [],
        contactActivities: [],
        message: null,
      };
    }
    return { message: "Get user info failed." };
  } catch (error) {
    return {
      message: "Failed to get contact. ",
    };
  }
};


function* getPaymentCreatedBy({ payload }) {
  try {
    const returnedData = yield call(getPaymentCreatedByAsync, payload);
    if (!returnedData.message) {
      yield put(
        getPaymentMethodCreatedBySuccess({
          contact: returnedData.contact,
          contactTypes: returnedData.contactTypes,
          contactActivities: returnedData.contactActivities,
        })
      );
    } else {
      yield put(getPaymentMethodCreatedByError(returnedData.message));
    }
  } catch (error) {
    yield put(getPaymentMethodCreatedByError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetPayment),
    fork(watchGetPaymentMethod),
    fork(watchGetPaymentCreatedBy),

  ]);
}